import { Badge } from "@loot-os/ui/components/badge";
import { sizeBandLabelOfListingId } from "../lib/listingSizes";

/**
 * The size band of a StockX band row ("US M 10-10.5"), which its title no longer carries, so
 * staff can tell the band rows of one product apart. Renders nothing for any other listing.
 */
export function SizeBandBadge({ listingId }: { listingId: string }) {
  const label = sizeBandLabelOfListingId(listingId);
  if (label === null) return null;
  return (
    <Badge variant="outline" className="shrink-0 whitespace-nowrap text-[10px]">
      {label}
    </Badge>
  );
}
